import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { ChallanInModel } from '../../../model/index';
import { ChallanInService, SubscribeService } from '../../../services/index';


@Component({
    selector: 'challanin-tab',
    templateUrl: './challanIn.component.html',
})

export class ChallanInComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public challanindata: any[] = [];

    isLoadMask: Promise<any>;
    challaninData: ChallanInModel[];
    isLoading: boolean = false;

    constructor(private challaninService: ChallanInService, public subscribeService: SubscribeService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date()
    };
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'challan_in_id',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'C.In No', prop: 'challan_in_no', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'C.In Date', prop: 'disp_cdate', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'C.Out No', prop: 'challan_no', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Action', prop: 'sno', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-right', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });

        //THIS WILL WORK WHEN ENTRY SAVED IN OTHER TAB
        this.subscribeService.publishReloadChallanInListGrid().subscribe(($e) => {
            that.getChallaninList();
        });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getChallaninList();
        }
    }
    onOpenedFilter(){}

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getChallaninList();
    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getChallaninList();
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date()
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.page.offset = 0;
        this.filterPanel.close();
        this.getChallaninList();
    }

    getChallaninList(): void {
        let filterData = {
            ...this.filterData,
            from_date:moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date:moment(this.filterData['to_date']).format('YYYY-MM-DD')
        };
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter : JSON.stringify(filterData)
        };
        let that = this;
        this.isLoadMask = this.challaninService
            .getChallaninList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.challaninData = res.data;
            });
    }
   

    addChallanin(mode: string, row: any): void {
        let that = this;
        // setTimeout(function() {
        //     that.filterPanel.close();
        // }, 10);

        if (mode == "Add") {
            row = {
                challan_in_id: '',
                mode: mode
            };
        } else if (mode == "View") {
            row['mode'] = mode;
        }

        that.subscribeService.subScribeTabID('Transaction', 'AddEditChallanInComponent', row, this['params']['tabParams']);
    }

    onDeleteChallanin(row: any): void {
        let that = this,
            params = {
                challan_in_id: row.challan_in_id,
                challan_out_id: row.challan_out_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Challan In Details, No: ' + row['challan_no'],
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.loadingIndicator = true;
            that.isLoadMask = that.challaninService
                .deleteChallanin(params)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getChallaninList();
                        swal(
                            'DELETED',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {
        });

    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/challanIn/challanIn.component.ts